import { render, staticRenderFns } from "./GrcCompErrorBubble.vue?vue&type=template&id=06f3fce0&"
import script from "./GrcCompErrorBubble.vue?vue&type=script&lang=js&"
export * from "./GrcCompErrorBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports